export const REMOVE_FOLLOW_CARD = 'REMOVE_FOLLOW_CARD';

export const removeFollowCard = (id) => {
  return {
    type: REMOVE_FOLLOW_CARD,
    id,
  };
};
